/**
 * Shared Footer Component
 *
 * Reusable footer with navigation and copyright.
 */

import { Link } from '@tanstack/react-router'

const FOOTER_LINKS = [
	{ to: '/about', label: 'Om oss' },
	{ to: '/privacy', label: 'Integritetspolicy' },
	{ to: '/terms', label: 'Villkor' },
] as const

export function Footer() {
	return (
		<footer className="border-t border-border bg-background py-8">
			<div className="container mx-auto px-4">
				<div className="flex flex-col items-center justify-between gap-4 md:flex-row">
					<p className="text-sm text-muted-foreground">
						&copy; {new Date().getFullYear()} Företagsbörsen. Alla rättigheter förbehållna.
					</p>
					<nav className="flex gap-6 text-sm">
						{FOOTER_LINKS.map(link => (
							<Link
								key={link.to}
								to={link.to}
								className="text-muted-foreground transition-colors hover:text-foreground"
							>
								{link.label}
							</Link>
						))}
					</nav>
				</div>
			</div>
		</footer>
	)
}

export default Footer
